import React from "react";
import { useNavigate } from "react-router-dom";
import { closeModal } from "react-url-modal";
import { Modal, Button } from "@/components";
import styles from "./SuccessDeleteTournamentModal.module.scss";
import successDeleteGameIcon from "@/assets/img/successDelete.svg";
import { useCurrentWidth } from "@/hooks";
import { MediaBreakPoints } from "@/resources/constants";

interface SuccessDeleteTournamentModalProps {
  setIsOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  params?: Record<string, any>;
}

const SuccessDeleteTournamentModalComponent = ({
  setIsOpen,
  params = {},
}: SuccessDeleteTournamentModalProps): JSX.Element => {
  const navigate = useNavigate();
  const windowWidth = useCurrentWidth();
  const isMobile = windowWidth <= MediaBreakPoints.DESKTOP;

  const handleClose = () => {
    closeModal();
    navigate("/padel/tournaments/my");
    if (setIsOpen) {
      setIsOpen(false);
    }
  };

  return (
    <Modal
      title="Турнир успешно удален!"
      subTitle=""
      isOpen={true}
      setIsOpen={setIsOpen || (() => {})}
      closeModal={handleClose}
      firmBack
    >
      <div className={styles.content}>
        <img 
          src={successDeleteGameIcon} 
          alt="success delete tournament" 
          className={styles.image} 
        />
        {
          isMobile && (
            <div className={styles.mobileContent}>
              <span className={styles.mobileTitle}>
                Турнир успешно удален
              </span>
            </div>
          )
        }
        <Button onClickFunc={handleClose} newStyles={styles.button}>
          Вернуться в "Мои турниры"
        </Button>
      </div>
    </Modal>
  );
};

export default SuccessDeleteTournamentModalComponent;
export const SuccessDeleteTournamentModal = SuccessDeleteTournamentModalComponent;


